export default function HotelDetailsController(
    $scope,
    $stateParams,
    $location,
    $anchorScroll,
    $sce,
    $rootScope,
    deviceDetector,
    hotelDetails,
    basketService
) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        Object.assign($scope, {
            params: $stateParams,
            tripAdvisor: null,
            activeTab: 1,
            hotelDetails: processHotelDetails(hotelDetails),
            pageHeading: hotelDetails.Hotel.Name,
            isMobile: deviceDetector.isMobile(),
            tripAdvisorReviewsWidgetUrl: $sce.trustAsResourceUrl(hotelDetails.Hotel.TripAdvisorReviewsWidgetUrl),
            tripAdvisorReviewsMobileWidgetUrl: $sce.trustAsResourceUrl(hotelDetails.Hotel.TripAdvisorReviewsMobileWidgetUrl),
        });
    }

    function processHotelDetails(details) {
        details.Hotel.Links = _.uniq(details.Hotel.Links);
        details.RoomInformation = details.RoomInformation
            ? details.RoomInformation.split(';')
            : null;
        return details;
    }

    $scope.fullDescriptionToggle = {
        show: _.some( // showMoreInformation == true when any item is 'truthy'
            _.values( // grab the values for each key
                _.pick( // use only the keys from the full description
                    hotelDetails,
                    ['DinningInformation', 'CheckInInstructions', 'OtherInformation']
                )
            ),
            _.identity
        ),
        expanded: false,
    };

    $scope.addToBasket = basketService.addHotel.bind(null);
    $scope.scrollTo = function(id) {
        $location.hash(id);
        $anchorScroll();
    };

    $scope.isSelected = function(checkTab) {
        return $scope.activeTab === checkTab;
    };

    $scope.selectTab = function(tabIndex) {
        $scope.activeTab = tabIndex;
    };

    $scope.sortColumn = function(col) {
        return function(item, index) {
            const len = $scope.hotelDetails.Hotel.Benefits.length;
            return (len < 2)
                ? true
                : (index < ((len / 3) * col)) && (index >= ((len / 3) * (col - 1)));
        };
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/details/hotel-details-controller.js